import React , {Component} from "react";
import {
  HashRouter,
  Route
} from "react-router-dom";

import MyProvider from "./components/MyProvider.jsx";
import "./app-layout.scss";
import MyContext from './components/MyContext.jsx';
import Header from "./components/Header/Header.jsx";
import Login from "./components/Login/Login.jsx";
import Home from "./components/Home/Home.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import SalesOrders from "./components/Sales/Orders.jsx";
import SalesOrder from "./components/Sales/NewOrder.jsx";
import Schedules from "./components/Schedules/Schedules.jsx";
import NewSchedule from "./components/Schedules/NewSchedule.jsx";
import ScheduleDetails from "./components/Schedules/ScheduleDetails.jsx";
import Leads from "./components/Leads/Leads.jsx";
import NewLeads from "./components/Leads/NewLeads.jsx";
import Collections from "./components/Collections/Collections.jsx";
import NewCollection from "./components/Collections/NewCollection.jsx";
import MarketingMenu from "./components/Marketing/Menu.jsx";
import MarketingBrand from "./components/Marketing/Brand.jsx";
import MarketingProduct from "./components/Marketing/Product.jsx";
import MarketingDealer from "./components/Marketing/Dealer.jsx";
import MarketingInfluencer from "./components/Marketing/Influencer.jsx";
import InfluencerFeedback from "./components/Marketing/InfluencerFeedback.jsx";
import MarketingAnalysis from "./components/Marketing/MarketingAnalysis.jsx";
import PriceList from "./components/PriceList/PriceList";

import AttendanceLeave from "./components/Attendance/AttendanceLeave.jsx";



/******** WEB REPORTS *******/

import Reports from "./components/Reports/ReportList";
import SalesReport from "./components/Reports/SalesReport.jsx";
import DealerWiseReport from "./components/Reports/DealerWiseReport.jsx";
import ExecutiveWiseReport from "./components/Reports/ExecutiveWiseReport.jsx";
import SalesOrderReport from "./components/Reports/SalesOrderReport.jsx";
import AveragePriceReport from "./components/Reports/AveragePriceReport.jsx";

/************  WEB REPORTS **************/

/*****Others********/
import Outstanding from "./components/Others/Outstanding.jsx";
import Targets from "./components/Others/Targets.jsx";
import TravelAllowance from "./components/TravelAllowance/TravelAllowance.jsx";
import NewTravelAllowance from "./components/TravelAllowance/NewTravelAllowance.jsx";

/*****Nita*********/
import NewVisit from "./components/Schedules/NewVisit.jsx";


/*****Nita*********/

import Loading from "./components/Loading/Loading.jsx";
import BottomNavbar from "./components/BottomNavbar/BottomNavbar.jsx";
// import DevTools from "./components/DevTools/DevTools.jsx";
import InDev from "./components/DevTools/InDev.jsx";
import MyAttendanceReport from "./components/Reports/MyAttendanceReport.jsx";
import MyVisitReport from "./components/Reports/MyVisitReport.jsx";
import PerformanceDashboard from "./components/PerformanceDashboard/PerformanceDashboard.jsx";
import ScheduledRoutes from "./components/RouteSchedules/ScheduledRoutes.jsx";
import NewScheduleRoute from "./components/RouteSchedules/NewScheduleRoute.jsx";
import DayPlan from "./components/DayPlan/DayPlan.jsx";
import DayPlanDetails from "./components/DayPlan/DayPlanDetails.jsx";
import NewRoute from "./components/RouteManagement/NewRoute.jsx";
import Routes from "./components/RouteManagement/Routes.jsx";
import ScheduleApproval from "./components/RouteSchedules/ScheduleApproval/ScheduleApproval.jsx";
import Customers from "./components/Dealer/Customers.jsx";
import NewCustomer from "./components/Dealer/NewCustomer.jsx";
import AttendanceCamera from "./components/AttendanceCamera/AttendanceCamera.jsx";
import JointVisits from "./components/JointVisit/JointVisits.jsx";
import NewJointVisits from "./components/JointVisit/NewJointVisit.jsx";
import LeadDetails from "./components/DayPlan/LeadDetails.jsx";
import DaySummary from "./components/DaySummary/DaySummary.jsx";
import Attachment from "./components/Attachment/Attachment.jsx";
import ReturnOrders from "./components/SalesReturn/ReturnOrders.jsx";
import NewReturnOrder from "./components/SalesReturn/NewReturnOrder.jsx";
class App extends Component{
  render(){
    return (
      <MyProvider> 
        <HashRouter>
          <Route path="/" component={Header} />
          <div className="app_content">
            <Route exact path="/" component={Login} />
            <Route exact path={window.project_path+"/index.html"} component={Login} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/salesorders" component={SalesOrders} />
            <Route exact path="/salesorders/new" component={SalesOrder} />
            <Route exact path="/salesorders/edit/:sid" component={SalesOrder} />
            <Route exact path="/schedules" component={Schedules} />
            <Route exact path="/schedules/new" component={NewSchedule} />
            <Route exact path="/schedules/details/:sched_id" component={ScheduleDetails} />
            <Route exact path="/schedules/details/edit/:edit_sched_id" component={ScheduleDetails} />
            <Route exact path="/leads" component={Leads} />
            <Route exact path="/leads/new" component={NewLeads} />
            <Route exact path="/leads/edit/:lead_id" component={NewLeads} />
            <Route exact path="/collections" component={Collections} />
            <Route exact path="/collections/new" component={NewCollection} />
            <Route exact path="/collections/edit/:coll_id" component={NewCollection} />
            <Route exact path="/marketing" component={MarketingMenu} />
            <Route exact path="/marketing/brand" component={MarketingBrand} />
            <Route exact path="/marketing/product" component={MarketingProduct} />
            <Route exact path="/marketing/dealer" component={MarketingDealer} />
            <Route exact path="/marketing/influencer" component={MarketingInfluencer} />
            <Route exact path="/marketing/influencer/feedback" component={InfluencerFeedback} />
            <Route exact path="/marketing/analysis" component={MarketingAnalysis} />
            <Route exact path="/outstandings" component={Outstanding} />
            <Route exact path="/targets" component={Targets} />
            <Route exact path="/travel/allowance" component={TravelAllowance} />
            <Route exact path="/travel/allowance/new" component={NewTravelAllowance} />
            <Route exact path="/travel/allowance/edit/:ta_id" component={NewTravelAllowance} />
            <Route exact path="/new/visit" component={NewVisit} />
            <Route exact path="/pricelist" component={PriceList}/>

            <Route exact path="/employee/attendance/leave" component={AttendanceLeave} />

            {/* <Route exact path="/employee/attendance/punchin" component={AttendanceCamera} /> */}
            <Route exact path="/punchin" component={AttendanceCamera} />


            <Route exact path="/dayplan" component={DayPlan} />
            <Route exact path="/dayplan/details/:sched_id" component={DayPlanDetails} />
            <Route exact path="/dayplan/details/edit/:edit_sched_id" component={DayPlanDetails} />

            <Route exact path="/dayplan/lead/details/:lead_id" component={LeadDetails} />
            <Route exact path="/dayplan/lead/details/edit/:edit_lead_id" component={LeadDetails} />

            <Route exact path="/routes/new"component={NewRoute}/>
            <Route exact path="/routes/edit/:route_id"component={NewRoute}/>
            <Route exact path="/routes"component={Routes}/>

            <Route exact path="/schedule/routes" component={ScheduledRoutes} />
            <Route exact path="/schedules/routes/new" component={NewScheduleRoute} />


            <Route exact path="/customers" component={Customers} />
            <Route exact path="/customers/new" component={NewCustomer} />

            {/* Route Approval */}
            <Route exact path="/schedule/routes/approval" component={ScheduleApproval} />


            <Route exact path ="/jointvisits" component = {JointVisits} />
            <Route exact path ="/jointvisits/new" component = {NewJointVisits} />


             {/* REPORTS */}
            <Route exact path="/reports" component={Reports} />
            <Route exact path="/salesreport" component={SalesReport} />
            <Route exact path="/dealerwisereport" component={DealerWiseReport} />
            <Route exact path="/executivewisereport" component={ExecutiveWiseReport} />
            <Route exact path="/salesorderreport" component={SalesOrderReport} />
            <Route exact path="/averagepricereport" component={AveragePriceReport} />
            <Route exact path="/myattendancereport" component={MyAttendanceReport} />
            <Route exact path="/myvisitreport" component={MyVisitReport} />

            <Route exact path="/performanceDashboard" component={PerformanceDashboard} />

            <Route exact path="/daySummary" component={DaySummary} />

            <Route exact path="/catalogue/attachment" component={Attachment} />

            <Route exact path="/salesreturn" component={ReturnOrders}/>
            <Route exact path="/salesreturn/new" component={NewReturnOrder}/>
            <Route exact path="/salesreturn/edit/:sale_return_id" component={NewReturnOrder} />

            {/* REPORTS */}
          </div>
          <Route path="/" component={Loading} />
          <Route path="/" component={BottomNavbar} />
         {/* <Route path="/" component={DevTools} />*/}
        </HashRouter>
      </MyProvider>
    );
  }
}

export default App;
App.contextType = MyContext;
